module.exports = __webpack_public_path__ + "img/saddle-cloths-19.646d3f70.svg";